import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import extAxios from '../../services/extAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    eventos: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    fechaInicioDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaInicioHasta: moment(new Date()).format('YYYY-MM-DD'),
    cliente: null,
    tipoEvento: null,
    sortByDescending: true,

    searchList: [],

    eventosActivos: [],
    proximosEventos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_EVENTOS' (state) {
        state.eventos = [];
    },
    'SET_EVENTOS' (state, eventos) {
        state.eventos = eventos;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_SEARCH_LIST' (state) {
        state.searchList = [];
    },
    'SET_SEARCH_LIST' (state, searchList) {
        state.searchList = searchList;
    },

    'INICIALIZAR_EVENTOS_ACTIVOS' (state) {
        state.eventosActivos = [];
    },
    'SET_EVENTOS_ACTIVOS' (state, eventosActivos) {
        state.eventosActivos = eventosActivos;
    },

    'INICIALIZAR_PROXIMOS_EVENTOS' (state) {
        state.proximosEventos = [];
    },
    'SET_PROXIMOS_EVENTOS' (state, proximosEventos) {
        state.proximosEventos = proximosEventos;
    },
};

const getters = {
    getField,

    searchList(state) {
        return state.searchList;
    },
    eventosActivos(state) {
        return state.eventosActivos;
    },
    proximosEventos(state) {
        return state.proximosEventos;
    },
};

const actions = {
    getEventos ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_EVENTOS');

            let queryString = '?fechaDesde='+ moment(state.fechaInicioDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaInicioHasta).format('YYYY-MM-DD')
                + '&pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;
            
            if (state.cliente) {
                if (state.cliente.id != 0) {
                    queryString += '&clienteId=' + state.cliente.id;
                }
            }
            if (state.tipoEvento) {
                if (state.tipoEvento.id != 0) {
                    queryString += '&tipoEventoId=' + state.tipoEvento.id;
                }
            }

            if (!(/true/i).test(state.sortByDescending)) {
                queryString += '&sortByDescending=false';
            }
            
            apiAxios.get('eventos' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_EVENTOS', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getSearchList ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_SEARCH_LIST');

            let queryString = '';
            
            if (params) {
                if (params.clienteId) {
                    queryString = '?clienteId=' + params.clienteId;
                }
                if (params.tipoEventoId) {
                    queryString += (queryString.trim() == ''? '?' : '&') 
                        + 'tipoEventoId=' + params.tipoEventoId;
                }
            }

            apiAxios.get('eventos/list' + queryString)
                .then(res => {
                    commit('SET_SEARCH_LIST', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getEventosActivos ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_EVENTOS_ACTIVOS');

            apiAxios.get('eventos/activos')
                .then(res => {
                    commit('SET_EVENTOS_ACTIVOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getProximosEventos ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PROXIMOS_EVENTOS');

            apiAxios.get('eventos/proximos')
                .then(res => {
                    commit('SET_PROXIMOS_EVENTOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    delete ( {}, eventoId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('eventos/' + eventoId + '/delete')
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    descargarImagenesParticipantes: ( {}, eventoId ) => {
        return new Promise((resolve, reject) => {
            apiAxios.get(`eventos/${eventoId}/imagenes/participantes/descargar` ) 
                .then(res => {
                    if (res.data == '') {
                        reject('Los participantes del evento no tienen archivos asociados.')
                        return null;
                    }
                    
                    return extAxios.get(res.data, {responseType: 'blob'});
                })
                .then(res => {
                    if (res) {
                        saveAs(res.data, 'download.zip');
                    }
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },    
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}